export default __webpack_public_path__ + "static/media/S0020.34I-26471_-17356_0.1666270620000.ee8de378.jpg";